
import { MessageBox } from 'element-ui'
import commonService from '@/api/common'

const trans = Symbol('trans')

const transformTraditional = {
  bind(el, binding) {
    const target = el.querySelector('input,textarea')
    const { value } = binding

    if (target) {
      const wrapperHandler = (e) => handler(e, value)
      const destroy = () => target.removeEventListener('blur', wrapperHandler)

      target.addEventListener('blur', wrapperHandler)

      el[trans] = {
        destroy
      }
    }
  },

  unbind(el) {
    el[trans] && el[trans].destroy && el[trans].destroy()
  }
}

async function handler(e, label = '文本') {
  const oldValue = e.target.value

  if (!oldValue) {
    return
  }

  await transComplexText(oldValue, label, (value) => {
    e.target.value = value
    e.target.dispatchEvent(new CustomEvent('input'))
  })
}

async function transComplexText(text, label, callback) {
  try {
    const { simpleChineseData, isChanged } = await commonService.transComplexFont({
      traditionalChineseData: text
    })

    if (isChanged) {
      await MessageBox.confirm(`${label}内存在繁体，请确认是否转换简体`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

      callback(simpleChineseData)
    }
  } catch (e) {
    //
  }
}

function install(Vue) {
  Vue.directive('trans-complex', transformTraditional)
  Vue.prototype.$transComplexText = transComplexText
}

export default {
  install,
}
